const origin = window.location.origin;
const pathname=window.location.pathname;
const isRedirected = () => !origin.includes("holonext.io") ? window.location.href = "https://holonext.io"+pathname : false;
export default isRedirected;
